import { EVENT_TYPES } from "nemuru-components";
import { MILESTONES } from "../../../components/shared/sharedKernel/EventCatcher/config";
import { FLOW_MESSAGES } from "../../../components/shared/components/flowMessages/components";
import { modules } from "../../../components/modules";
import { SECTIONS } from "../../config";

export const flowVideoId = {
  name: "Video ID",
  modules: [
    {
      id: modules.VIDEO_ID.id,
      section: {
        name: SECTIONS.IDENTIFICATION,
        progressPercentage: "50%",
      },
      onOK: {
        showOKMessage: {
          id: FLOW_MESSAGES.SECTION_IDENTIFICATION_END.id,
          fadeIn: true,
        },
        sendEvents: [
          {
            name: MILESTONES.KYC_COMPLETED,
            type: EVENT_TYPES.milestoneCompleted,
          },
        ],
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) => {
          return processState.videoIdProcessPassed === undefined;
        },
        welcomeMessageId: FLOW_MESSAGES.VIDEO_ID_WELCOME_MESSAGE.id,
      },
    },
    {
      id: modules.VIDEO_ID_RESULT.id,
      onKO: null,
      section: {
        name: SECTIONS.IDENTIFICATION,
        progressPercentage: "100%",
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          processState.videoIdProcessPassed !== undefined,
      },
    },
  ],
};
